export default __webpack_public_path__ + "static/media/FSIndustrieCd-Medium.8d304415.ttf";